import React, { FC, ReactNode } from "react";

import { InfoOutlined } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";

interface IgHeaderWTooltipProps {
  sectionTitle: string;
  tooltipMessage: ReactNode;
  fontWeight?: number;
  fontSize?: string;
}

/**
 * @see IgTooltip
 * @see Grid
 * @see IconButton
 */
export const IgHeaderWTooltip: FC<IgHeaderWTooltipProps> = ({
  tooltipMessage,
  sectionTitle,
  fontWeight,
  fontSize,
}) => {
  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      id={"ig-header-w-tooltip"}
    >
      <Grid item id={"ig-header-w-tooltip-section-title-grid"}>
        <IgTypography
          sx={{ fontWeight: fontWeight || 500, fontSize: fontSize || "16px" }}
        >
          {sectionTitle}
        </IgTypography>
      </Grid>
      <Grid item id={"ig-header-w-tooltip-tooltip-grid"}>
        <IgTooltip
          title={
            <p>
              <>{tooltipMessage}</>
            </p>
          }
        >
          <IconButton size={"small"} aria-label="info">
            <InfoOutlined fontSize={"small"} />
          </IconButton>
        </IgTooltip>
      </Grid>
    </Grid>
  );
};
